<template>
  <div class="pop-widget" ref="pop_widget">
      <div class="pop-content">
          <div class="pop-head">
              <div class="title">
                  {{title}}
              </div>
              <span class="close" @click="closePop">关闭</span>
          </div>
          <div class="pop-tip">
              <slot></slot>
              <span class="orange-btn" @click="handleSubmit">提交</span>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  name: 'PopWidget',
  props: {
    title: String
  },
  mounted() {
    this.$refs.pop_widget.style.width = document.querySelector('body').clientWidth + 'px'
    this.$refs.pop_widget.style['margin-left'] = 0-document.querySelector('body').clientWidth/2 + 'px'
  },
  methods: {
    closePop() {
      console.log('this.closePop')
        this.$emit('close', {}, {})
    },
    sub() {
      this.$emit('subscribe', {}, {})
    },
    handleSubmit() {
      this.$emit('submit', {}, {})
    }
  }
}
</script>
<style scoped>
/* components/popwidget/index.wxss */
.pop-widget{
    position: fixed;
    top: 0;
    left: 50%;
    height: 100%;
    min-height: 100vh;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999999;
}
.pop-content{
    position: absolute;
    padding-bottom: 20px;
    bottom: 0;
    width: 100%;
    min-height: 300px;
    height: auto;
    background-color: white;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
}
.pop-head{
    height: 40px;
    line-height: 40px;
    text-align: right;
    padding-top: 10px;
    position: relative;
}
.close {
    position: absolute;
    top: 10px;
    right: 25px;
    font-size: 12px;
}
.pop-tip{
    text-align: center;
    padding: 10px 20px 0 20px;
}
.orange-btn{
    margin-top: 20px;
    text-align: center;
    background-color: var(--primary-color);
    color: white;
    font-size: 14px;
    width: 100%;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    border-radius: 25px;
}
.title{
    text-align: center;
    font-size: 20px;
}
</style>